import { endpoints } from 'Constants';

const services = {
	getCouponList: (filter) => ({
		baseURL: endpoints.COUPON?.INDEX(filter),
		method: 'GET',
	}),
	invalidateCoupon: (filter) => ({
		baseURL: endpoints.COUPON?.INVALIDATE(filter.id),
		method: 'POST',
		data: {
			control_code: filter.control_code,
		},
	}),
	getCouponListBaseOnMobile: (filter) => ({
		baseURL: endpoints.COUPON?.INDEX_PER_MOBILE(filter),
		method: 'GET',
	}),
	getCouponListByOrderId: (filter) => ({
		baseURL: endpoints.COUPON?.SEARCH_ORDER_ID(filter),
		method: 'GET',
	}),
	getMerchantInvalidationSearch: (filter) => ({
		baseURL: endpoints.COUPON?.MERCHANT_INVALIDATION_SEARCH(filter),
		method: 'GET',
	}),
};

export default services;
